/* eslint-disable
    no-console,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const SecondarySearch = () => ({
   controllerAs: 'secondarySearch',
   controller: SecondarySearchController,
   templateUrl: '/assets/secondarySearchWidget.html'
})


const SecondarySearchResults = () => ({
   controllerAs: 'secondaryResults',
   controller: SecondarySearchResultsController,
   templateUrl: '/assets/secondarySearchWidgetResults.html',

   bindToController: {
      results: '<',
      count: '<'
   }
})


class SecondarySearchService {
   $http: any
   $window: any
   acService: any
   advancedService: any
   config: any
   count: any
   dataService: any
   enableAutoSearch: any
   maxResultSize: any
   prev_query: any
   query: any
   results: any
   searchError: any
   searchUrl: any
   site: any
   siteName: any
   constructor($http: any, $window: any, acService: any, advancedService: any,  dataService: any, config: any) {
      this.onNewQuery = this.onNewQuery.bind(this)
      this.$http = $http
      this.$window = $window
      this.acService = acService
      this.advancedService = advancedService
      this.dataService = dataService
      this.config = config
      this.results = []
      this.count = -1
      this.prev_query = ''
      this.query = ''
      this.maxResultSize = 3
      this.searchError = false
      this.siteName = this.config.data.widgets.secondaryClient.name
      this.site =  this.buildSecondarySiteUrl()
      this.searchUrl = "api/secondarysearch"
      this.enableAutoSearch = true // TODO:: Determine if this property is configurable
      this.dataService.on('new', this.onNewQuery)
   }

   buildSecondarySiteUrl() {
      const currentClient = this.config.data.head.client
      if (this.$window.location.origin.indexOf(currentClient) !== -1) {
         return this.$window.location.origin.replace(currentClient, this.siteName)
      } else {
         return `https://${this.siteName}.summon.serialssolutions.com`
      }
   }

   clear() {
      this.results = []
      this.count = -1
      return this.searchError = false
   }

   clearSearch() {
      this.clear()
      return this.query = ''
   }

   updateData(results: any) {
      return this.results = results
   }

   search(query: any) {
      this.query = query
      if (this.query.length === 0) {
         return // only search if there's something to search
      }

      this.prev_query = this.query
      const url = `${this.searchUrl}?q=${this.query}`
      return this.$http.get(url)
         .then((res: any) => { 
            const results = res.data.documents.map(function(r: any) { 
               r.search_result = true // indicator for render template display
               return r
            })
            this.count = res.data.record_count
            return this.updateData(results)
         }).catch((err: any) => { 
            console.error(err)
            this.clear()
            return this.searchError = true
         })
   }

   // some simple heuristics to determine if we should
   // 1. Parse advanced search queries 'TitleCombined:"(foo)"' and only use values
   // 2. Try and only grab values from index searches (that happen after clicking subject or author for example)
   // 3. Do not search very long queries
   parseQuery(q: any) {
      if (/([^:]+):\(.+?\)?/.test(q)) {
         const queryValues = this.advancedService.parseQueryToAdvancedQueryValues(q)
         if (queryValues && queryValues.length) { 
            return queryValues.join(' ')
         }
      }
      if (/([^:]+):".+?"/.test(q)) {
         const matches = q.match(/[^:]+:"([^"]+)"/)
         if (matches && matches.length) {
            return matches[1]
         } else { 
            return ''
         }
      }
      if (q.length > 150) {
         return ''
      }
      return q
   }

   onNewQuery(q: any) {
      const current_query = q.query.original_query
      if (!this.enableAutoSearch) {
         this.clear()
         return
      }

      if (this.prev_query !== current_query) { 
         this.clear()
         this.query = this.parseQuery(current_query)
         return this.search(this.query)
      }
   }
}


SecondarySearchService.$inject = ['$http', '$window', 'autocompleteService', 'advancedSearchService', 'dataService', 'configService']

class SecondarySearchController {
   $scope: any
   clear: any
   count: any
   maxResultSize: any
   query: any
   secondarySearchService: any
   secondarySiteName: any
   constructor($scope: any, secondarySearchService: any, config: any) {
      this.submit = this.submit.bind(this)
      this.$scope = $scope
      this.secondarySearchService = secondarySearchService
      this.query = ''
      this.count = this.secondarySearchService.count
      this.maxResultSize = this.secondarySearchService.maxResultSize
      this.clear = this.secondarySearchService.clear
      this.secondarySiteName = this.secondarySearchService.siteName
   }

   $onInit() {
      return this.$scope.$watchCollection('secondaryResults', (newResults: any) => {
         return this.query = this.secondarySearchService.query
      })
   }

   clearSearch(data: any) {
      this.clear()
      this.query = ''
      return this.secondarySearchService.clearSearch()
   }

   onSelect(data: any) {
      this.clear()
      data.search_result = true // indicator for render template display
      this.secondarySearchService.updateData([data])
      return this.$scope.$apply()
   }

   submit() {
      this.clear()
      return this.secondarySearchService.search(this.query)
   }
}

SecondarySearchController.$inject = ['$scope', 'secondarySearchService', 'configService']


class SecondarySearchResultsController {
   $scope: any
   $window: any
   maxResultSize: any
   secondaryBaseUrl: any
   secondarySearchService: any
   secondarySiteName: any
   secondaryUrl: any
   constructor($scope: any, $sce: any, $window: any, secondarySearchService: any) {
      this.$scope = $scope
      this.$window = $window
      this.secondarySearchService = secondarySearchService
      this.secondaryBaseUrl = this.secondarySearchService.site 
      this.maxResultSize = this.secondarySearchService.maxResultSize
      this.secondarySiteName = this.secondarySearchService.siteName
   }

   $onInit() {
      return this.$scope.$watchCollection('secondaryResults.results', (newResults: any) => {
         return this.secondaryUrl = this.secondaryBaseUrl + "/#!/search?q=" + this.secondarySearchService.query
      })
   }
}

SecondarySearchResultsController.$inject = ['$scope', '$sce', '$window', 'secondarySearchService']

angular.module('summonApp.directives')
   .service('secondarySearchService', SecondarySearchService)
   .controller('secondarySearchResultsController', SecondarySearchResultsController)
   .controller('secondarySearchController', SecondarySearchController)
   .directive('secondarySearch', SecondarySearch)
   .directive('secondarySearchResults', SecondarySearchResults)

